<template>
  <el-carousel height="37px" direction="vertical" :autoplay="true" indicator-position="none" :loop="true">
    <el-carousel-item v-for="(item, index) in userInfoList" :key="index">
      <h3 class="medium"> <img src="https://s21.lgstatic.com/growth/activity/20210824/1629796218667.png" alt="" /> {{ item.userName }} 同学  已预约学习</h3>
    </el-carousel-item>
  </el-carousel>
</template>
<script>
export default {
  props: {
    userInfoList: {
      type: Array,
      default: () => []
    }
  },
  data() {

  }
}
</script>
<style lang="less" scoped>
  /deep/.el-carousel__container {
    border-radius: 37PX;
    background-color: #D90E0E;
    line-height: 37PX;
  }
  .el-carousel__item h3 {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    background-color: transparent;
    font-size: 16PX;
    height: 37PX;
    line-height: 37PX;
    margin: 0;

    img {
      width: 16PX;
      height: 16PX;
      object-fit: contain;
      margin-right: 8PX;
      flex-shrink: 0;
    }
  }
</style>
